import { atom } from 'jotai';
import type { AuthTokens, AuthUser } from '../types';

export const authTokensAtom = atom<AuthTokens | null>(null);
export const authUserAtom = atom<AuthUser | null>(null);
export const authLoadingAtom = atom<boolean>(true);
export const authErrorAtom = atom<string | null>(null);

export const isAuthenticatedAtom = atom(
  (get) => get(authTokensAtom) !== null && get(authUserAtom) !== null,
);
